/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FoodDiaryDto } from './foodDiaryDto';


export interface FoodDiarySettingsDto { 
    consentGiven?: boolean;
    lastOptInDate?: string | null;
    lastOptOutDate?: string | null;
    profile?: FoodDiaryDto;
}

